import { useExportIntegrationIndex } from '@jobilla/nexus-sdk'
import { useJobillaOrgId } from './useJobillaOrgId'

export type AtsDeactivation =
	| { kind: 'scheduled'; date: string }
	| { kind: 'deactivated'; date: string }

export function useAtsDeactivation(): AtsDeactivation | null {
	const organisationId = useJobillaOrgId()
	const { data } = useExportIntegrationIndex(
		{ 'filter[organisation_id]': organisationId },
		{ enabled: !!organisationId, staleTime: 5 * 60 * 1000 },
	)

	const deactivated = data?.find((integration) => integration.deactivatedAt)
	if (deactivated?.deactivatedAt) {
		return { kind: 'deactivated', date: deactivated.deactivatedAt }
	}

	const scheduled = data?.find((integration) => integration.deactivationScheduledFor)
	if (scheduled?.deactivationScheduledFor) {
		return { kind: 'scheduled', date: scheduled.deactivationScheduledFor }
	}

	return null
}
